"use strict";
var $ = require("../internals/export");
var fails = require("../internals/fails");
var toObject = require("../internals/to-object");
var toPrimitive = require("../internals/to-primitive");
var FORCED = fails(function() {
  return (/* @__PURE__ */ new Date(NaN)).toJSON() !== null || Date.prototype.toJSON.call({ toISOString: function() {
    return 1;
  } }) !== 1;
});
$({ target: "Date", proto: true, arity: 1, forced: FORCED }, {
  // eslint-disable-next-line no-unused-vars -- required for `.length`
  toJSON: function toJSON(key) {
    var O = toObject(this);
    var pv = toPrimitive(O, "number");
    return typeof pv == "number" && !isFinite(pv) ? null : O.toISOString();
  }
});
